<h4>Apply for a {{brandName}} Business Account</h4>

<form
    [formGroup]="userForm"
    (ngSubmit)="onSubmit()"
    name="apply-business-account-form"
>
    <div class="row">
        <div class="col-md-5">
            <div
                class="col-md-12"
                style="margin-bottom: 20px;"
            ><span class="required fa fa-asterisk"></span> Indicates required fields.</div>
            <div class="form-group">
                <label>Company Name <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="companyName"
                    formControlName="companyName"
                    maxlength="128"
                    [ngClass]="{ 'is-invalid': f.companyName.dirty && f.companyName.errors?.required }"
                    autofocus
                />
                <small
                    class="error"
                    *ngIf="f.companyName.dirty && f.companyName.errors?.required"
                >Please enter a company name.</small>
            </div>

            <div class="form-group">
                <label>Industry <span class="required fa fa-asterisk"></span></label>
                <select
                    class="form-control"
                    name="industry"
                    formControlName="industry"
                    [ngClass]="{ 'is-invalid': f.industry.dirty && f.industry.errors?.required }"
                >
                    <option
                        *ngFor="let industry of industries"
                        [value]="industry"
                    >{{industry}}</option>
                </select>
                <span *ngIf="f.industry.value == 'Other (with text box)'">
                    <br />
                    <label>Industry (Other)</label>
                    <input
                        type="text"
                        class="form-control"
                        formControlName="otherIndustry"
                        name="otherIndustry"
                        [ngClass]="{ 'is-invalid': f.industry.dirty && f.industry.value === 'Other (with text box)' && !f.otherIndustry.value }"
                    />
                </span>
                <small
                    class="error"
                    *ngIf="(f.industry.dirty && f.industry.errors?.required) || (f.industry.value === 'Other (with text box)' && !f.otherIndustry.value)"
                >Please enter an industry.</small>
            </div>

            <div class="form-group">
                <label>Country <span class="required fa fa-asterisk"></span></label>
                <select
                    class="form-control"
                    name="country"
                    formControlName="country"
                    (change)="refreshRegions()"
                    [ngClass]="{ 'is-invalid': f.country.dirty && f.country.errors?.required }"
                >
                    <option
                        *ngFor="let country of countries"
                        [value]="country.id"
                    >{{country.name}}</option>
                </select>
                <small
                    class="error"
                    *ngIf="f.country.dirty && f.country.errors?.required"
                >Please enter a country.</small>
            </div>


            <div class="form-group">
                <label>Address/Street/PO Box <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="addressLine1"
                    formControlName="addressLine1"
                    maxlength="60"
                    [ngClass]="{ 'is-invalid': f.addressLine1.dirty && f.addressLine1.errors?.required }"
                />
                <small
                    class="error"
                    *ngIf="f.addressLine1.dirty && f.addressLine1.errors?.required"
                >Please enter an address.</small>
                <br />
                <input
                    type="text"
                    class="form-control"
                    name="addressLine2"
                    formControlName="addressLine2"
                    maxlength="60"
                />
            </div>

            <div class="form-group">
                <label>City <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="city"
                    formControlName="city"
                    maxlength="50"
                    [ngClass]="{ 'is-invalid': f.city.dirty && f.city.errors?.required }"
                />
                <small
                    class="error"
                    *ngIf="f.city.dirty && f.city.errors?.required"
                >Please enter a city.</small>
            </div>

            <div
                class="form-group"
                *ngIf="regions.length > 0"
            >
                <label>Province/State <span class="required fa fa-asterisk"></span></label>
                <select
                    class="form-control"
                    name="region"
                    formControlName="region"
                    (change)="onRegionSelectionChanged()"
                    [ngClass]="{ 'is-invalid': f.region.dirty && f.region.errors?.required }"
                >
                    <option
                        *ngFor="let region of regions"
                        [value]="region.abbreviation"
                    >{{region.name}}</option>
                </select>
                <small
                    class="error"
                    *ngIf="f.region.dirty && f.region.errors?.required"
                >Please select a province/state.</small>
            </div>

            <div
                class="form-group"
                *ngIf="regions.length == 0"
            >
                <label>Province/State <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="regionAbbrOrName"
                    formControlName="region"
                    maxlength="20"
                    [ngClass]="{ 'is-invalid': f.region.dirty && f.region.errors?.required }"
                />
                <small
                    class="error"
                    *ngIf="f.region.dirty && f.region.errors?.required"
                >Please enter a province/state.</small>
            </div>

            <div class="form-group">
                <label>Postal/Zip Code <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="postalCode"
                    formControlName="postalCode"
                    maxlength="20"
                    [ngClass]="{ 'is-invalid': f.postalCode.dirty && f.postalCode.errors?.required }"
                />
                <small
                    class="error"
                    *ngIf="f.postalCode.dirty && f.postalCode.errors?.required"
                >Please enter a postal code.</small>
            </div>

            <div class="form-group">
                <label>Contact First Name <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="contactFirstName"
                    formControlName="contactFirstName"
                    maxlength="50"
                    [ngClass]="{ 'is-invalid': f.contactFirstName.dirty && f.contactFirstName.errors?.required }"
                    autofocus
                />
                <small
                    class="error"
                    *ngIf="f.contactFirstName.errors?.pattern"
                >Only English characters are accepted.</small>
                <small
                    class="error"
                    *ngIf="f.contactFirstName.dirty && f.contactFirstName.errors?.required"
                >Please enter a contact first name.</small>
            </div>

            <div class="form-group">
                <label>Contact Last Name <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="contactLastName"
                    formControlName="contactLastName"
                    maxlength="50"
                    [ngClass]="{ 'is-invalid': f.contactLastName.dirty && f.contactLastName.errors?.required }"
                    autofocus
                />
                <small
                    class="error"
                    *ngIf="f.contactLastName.errors?.pattern"
                >Only English characters are accepted.</small>
                <small
                    class="error"
                    *ngIf="f.contactLastName.dirty && f.contactLastName.errors?.required"
                >Please enter a contact last name.</small>
            </div>

            <div class="form-group">
                <label>Salutation <span class="required fa fa-asterisk"></span></label>
                <select
                    class="form-control"
                    name="salutation"
                    formControlName="salutation"
                    [ngClass]="{ 'is-invalid': f.salutation.dirty && f.salutation.errors?.required }"
                >
                    <option
                        *ngFor="let salutation of salutations"
                        [value]="salutation"
                    >{{salutation}}</option>
                </select>
                <small
                    class="error"
                    *ngIf="f.salutation.dirty && f.salutation.errors?.required"
                >Please select a salutation.</small>
            </div>

            <div class="form-group">
                <label>Job Title <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="title"
                    formControlName="title"
                    maxlength="50"
                />
            </div>


            <div class="form-group">
                <label>Email address <span class="required fa fa-asterisk"></span></label>
                <input
                    type="email"
                    class="form-control"
                    name="email"
                    formControlName="email"
                    placeholder="Enter email"
                    maxlength="128"
                    autofocus
                    [ngClass]="{ 'is-invalid': f.email.dirty && ( f.email.errors?.required || f.email.errors?.email) }"
                />
                <small
                    class="error"
                    *ngIf="f.email.dirty && f.email.errors?.required"
                >Please enter an email.</small>
                <small
                    class="error"
                    *ngIf="f.email.dirty && f.email.errors?.email"
                >Please enter a valid email.</small>
            </div>

            <div class="form-group">
                <label>Phone Number <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    name="phone"
                    formControlName="phone"
                    [ngClass]="{ 'is-invalid': f.phone.dirty && f.phone.errors?.required }"
                />
                <small
                    class="error"
                    *ngIf="f.phone.dirty && f.phone.errors?.required"
                >Please enter a phone number.</small>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                By clicking the "Apply for account" button we will receive your application for a {{brandName}} Business Account. Once your application is reviewed, we will contact you using the contact information you have provided here.
            </div>
            <div class="form-group">
                <button
                    type="submit"
                    name="confirmationYesBtn"
                    class="btn btn-primary"
                >
                    Apply for account
                </button>
            </div>
        </div>
    </div>
</form>
